<template>
  <div>
  <Nav></Nav>
  <div class="content-container">
    <div class="columns">
      <div class="column is-centered">
        <router-view></router-view>
      </div>
    </div>
  </div>
  <!--  -->
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
export default {
  name: "account",
  components:{
    Nav
  }
};
</script>

<style scoped>

.content-container {
 /* background: #f7f7f7;*/
  width: 100%;
  height: 100vh;
}
@media only screen and (min-width: 768px) {
.content-container {
  padding: 3em;
  height: 100vh;
  /*background: #f7f7f7;*/
}
}

</style>
